export function checkSystem() {
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  console.log('是否是Android：' + isAndroid)
  console.log('是否是iOS：' + isiOS)
  if (isAndroid) {
    dynamicJs('android.js')
  } else if (isiOS) {
    dynamicJs('ios.js')
  }
}
export function dynamicJs(src) {
  var url = getRoot() + 'js/' + src
  console.log('当前页面引入的JS：' + url)
  try {
    var oHead = document.getElementsByTagName('head')[0]
    var oScript = document.createElement('script')
    oScript.type = 'text/javascript'
    oScript.src = url
    oHead.appendChild(oScript)
    console.log('--------------文件已加载完毕！！！------------>')
  } catch (err) {
    console.log(err)
  }
}
export function getRoot() {
  var hostname = location.hostname
  var pathname = location.pathname
  var contextPath = pathname.split('/')[1]
  var port = location.port
  var protocol = location.protocol
  return protocol + '//' + hostname + ':' + port + '/' + contextPath
}
